module.exports = __webpack_public_path__ + "img/web_neipu_4.b17a4a38.jpg";